/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2022-02-09 10:24:38
 */
// const statistics = () =>
//   import("@/views/finance-manage/statistics/statistics.vue");
// const memberRecharge = () =>
//   import("@/views/finance-manage/member-recharge/member-recharge.vue");
// const memberRechargeDetails = () =>
//   import(
//     "@/views/finance-manage/member-recharge/children/member-recharge-details.vue"
//   );
// const refundRecords = () =>
//   import("@/views/finance-manage/refund-records/refund-records.vue");
// const refundRecordsDetails = () =>
//   import(
//     "@/views/finance-manage/refund-records/children/records-details/records-details.vue"
//   );
// const refundRecordsAudit = () =>
//   import(
//     "@/views/finance-manage/refund-records/children/records-audit/records-audit.vue"
//   );
// const refundRecordsManage = () =>
//   import(
//     "@/views/finance-manage/refund-records/children/records-manage/records-manage.vue"
//   );
// const siteAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/site-accounting/site-accounting.vue"
//   );
// const moneyAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/children/site-accounting/children/money-accounting.vue"
//   );
// const powerAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/children/site-accounting/children/power-accounting.vue"
//   );
// const operationAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/operation-accounting/operation-accounting.vue"
//   );
// const userAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/user-accounting/user-accounting.vue"
//   );
// const rechargeAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/recharge-accounting/recharge-accounting.vue"
//   );
// const rechargeAmend = () =>
//   import(
//     "@/views/finance-manage/settlement/recharge-accounting/children/recharge-amend.vue"
//   );
// const refundAccounting = () =>
//   import(
//     "@/views/finance-manage/settlement/refund-accounting/refund-accounting.vue"
//   );
// const refundAmend = () =>
//   import(
//     "@/views/finance-manage/settlement/refund-accounting/children/refund-amend.vue"
//   );
// const amendPage = () =>
//   import("@/views/finance-manage/settlement/components/amend.vue");
// const amendRefundPage = () =>
//   import("@/views/finance-manage/settlement/components/amend.vue");
//
// const settlement = () =>
//   import("@/views/finance-manage/settlement/settlement.vue");
// const chargingOrder = () =>
//   import("@/views/finance-manage/charging-order/charging-order.vue");
// const withdrawal = () =>
//   import("@/views/finance-manage/withdrawal/withdrawal.vue");
// const cashTemplate = () =>
//   import(
//     "@/views/finance-manage/withdrawal/children/cash-template/cash-template.vue"
//   );
// const splitSettlement = () =>
//   import("@/views/finance-manage/split-settlement/split-settlement.vue");
// const splitSettlementErrorInfo = () =>
//   import(
//     "@/views/finance-manage/split-settlement/children/error-info/error-info.vue"
//   );
const routerList = [
    // {
    //   path: "/finance-manage/statistics",
    //   name: "财务统计",
    //   component: statistics,
    // },
    // {
    //   path: "/finance-manage/member-recharge",
    //   name: "会员充值记录",
    //   component: memberRecharge,
    // },
    // {
    //   path: "/finance-manage/member-recharge/details",
    //   name: "会员充值记录详情",
    //   component: memberRechargeDetails,
    //   meta: {
    //     nameKey: "memberRechargeDetails",
    //   },
    // },
    // {
    //   path: "/finance-manage/refund-records",
    //   name: "退款记录",
    //   component: refundRecords,
    // },
    // {
    //   path: "/finance-manage/refund-records/details",
    //   name: "退款记录详情",
    //   component: refundRecordsDetails,
    //   meta: {
    //     nameKey: "refundRecordsDetails",
    //   },
    // },
    // {
    //   path: "/finance-manage/refund-records/audit",
    //   name: "退款审核",
    //   component: refundRecordsAudit,
    //   meta: {
    //     nameKey: "refundRecordsAudit",
    //   },
    // },
    // {
    //   path: "/finance-manage/refund-records/manage",
    //   name: "退款管理",
    //   component: refundRecordsManage,
    //   meta: {
    //     nameKey: "refundRecordsManage",
    //   },
    // },
    // {
    //   path: "/finance-manage/settlement",
    //   name: "财务结算",
    //   component: settlement
    // },
    // {
    //   path: "/finance-manage/settlement/site-accounting",
    //   name: "站点核算",
    //   component: siteAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/site-accounting/money",
    //   name: "金额核算",
    //   component: moneyAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/site-accounting/power",
    //   name: "电量核算",
    //   component: powerAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/operation-accounting",
    //   name: "运营核算",
    //   component: operationAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/user-accounting",
    //   name: "用户核算",
    //   component: userAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/recharge-accounting",
    //   name: "充值核算",
    //   component: rechargeAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/recharge-accounting/amend/page",
    //   name: "修正充值核算",
    //   component: rechargeAmend,
    // },
    // {
    //   path: "/finance-manage/settlement/refund-accounting",
    //   name: "退款核算",
    //   component: refundAccounting,
    // },
    // {
    //   path: "/finance-manage/settlement/refund-accounting/amend/page",
    //   name: "修正退款核算",
    //   component: refundAmend,
    // },
    // {
    //   path: "/finance-manage/settlement/recharge-accounting/amend",
    //   name: "修正充值核算数据",
    //   component: amendPage,
    // },
    // {
    //   path: "/finance-manage/settlement/refund-accounting/amend",
    //   name: "修正退款核算数据",
    //   component: amendRefundPage,
    // },
    // {
    //   path: "/finance-manage/charging-order",
    //   name: "充电账单",
    //   component: chargingOrder,
    // },
    // {
    //   path: "/finance-manage/mch-settlement/withdrawal",
    //   name: "商户提现",
    //   // component: withdrawal,
    //   component: () =>
    //     import(
    //       "@/views/finance-manage/mch-settlement/mch-withdrawal/mch-withdrawal.vue"
    //     ),
    // },
    // {
    //   path: "/finance-manage/mch-settlement/withdrawal/add",
    //   name: "新增提现单",
    //   component: () =>
    //     import(
    //       "@/views/finance-manage/mch-settlement/mch-withdrawal/children/add-withdrawal/add-withdrawal.vue"
    //     ),
    //   meta: {
    //     nameKey: "addWithdrawal",
    //   },
    // },
    // {
    //   path: "/finance-manage/mch-settlement/withdrawal/details",
    //   name: "提现单详情",
    //   component: () =>
    //     import(
    //       "@/views/finance-manage/mch-settlement/mch-withdrawal/children/details-withdrawal/details-withdrawal.vue"
    //     ),
    //   meta: {
    //     nameKey: "detailsWithdrawal",
    //   },
    // },
    // {
    //   path: "/finance-manage/mch-settlement/withdrawal/template",
    //   name: "提现单模板",
    //   // component: cashTemplate,
    //   component: () =>
    //     import(
    //       "@/views/finance-manage/mch-settlement/mch-withdrawal/children/cash-template/cash-template.vue"
    //     ),
    //   meta: {
    //     nameKey: "withdrawalTpl",
    //   },
    // },
    {
        path: "/finance-manage/mch-settlement/mch-split-order",
        name: "运营商分成单",
        component: () => import("@/views/finance-manage/mch-settlement/mch-split-order/mch-split-order.vue"),
    },
    {
        path: "/finance-manage/mch-settlement/mch-bookkeeping-amount",
        name: "记账金额管理",
        component: () => import("@/views/finance-manage/mch-settlement/mch-bookkeeping-amount/mch-bookkeeping-amount.vue"),
    },
    // {
    //   path: "/finance-manage/split-settlement",
    //   name: "分成结算",
    //   component: splitSettlement,
    // },
    // {
    //   path: "/finance-manage/split-settlement/error-info",
    //   name: "分成结算异常信息",
    //   component: splitSettlementErrorInfo,
    // },
    {
        path: "/finance-manage/operator-daily-statement",
        name: "运营商日结单",
        component: () => import("@/views/finance-manage/operator-daily-statement/operator-daily-statement.vue"),
    },
    {
        path: "/finance-manage/operator-split-order",
        name: "运营商分成单",
        component: () => import("@/views/finance-manage/operator-split-order/operator-split-order.vue"),
    },
    {
        path: "/finance-manage/bookkeeping-amount",
        name: "记账金额管理",
        component: () => import("@/views/finance-manage/bookkeeping-amount/bookkeeping-amount.vue"),
    },
];
export default routerList;
